import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const ItemtypetreatmentsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		itemtypeid: yup.number().required().label("Itemtypeid"),
		treatmentid: yup.number().required().label("Treatmentid"),
		pricemultiplier: yup.number().nullable().label("Pricemultiplier"),
		isdefault: yup.string().nullable().label("Isdefault"),
		createdat: yup.string().nullable().label("Createdat")
	});
	
	//form default values
	const formDefaultValues = {
		itemtypeid: '', 
		treatmentid: '', 
		pricemultiplier: "((1.00))", 
		isdefault: "((0))", 
		createdat: "(getutcdate())", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/itemtypetreatments`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="ItemtypetreatmentsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Itemtypetreatment"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Itemtypeid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="itemtypeid"  onChange={formik.handleChange}  value={formik.values.itemtypeid}   label="Itemtypeid" type="number" placeholder="Enter Itemtypeid"  min={0}  step="any"    className={inputClassName(formik?.errors?.itemtypeid)} />
                                                <ErrorMessage name="itemtypeid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Treatmentid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="treatmentid"  onChange={formik.handleChange}  value={formik.values.treatmentid}   label="Treatmentid" type="number" placeholder="Enter Treatmentid"  min={0}  step="any"    className={inputClassName(formik?.errors?.treatmentid)} />
                                                <ErrorMessage name="treatmentid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pricemultiplier 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pricemultiplier"  onChange={formik.handleChange}  value={formik.values.pricemultiplier}   label="Pricemultiplier" type="number" placeholder="Enter Pricemultiplier"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.pricemultiplier)} />
                                                <ErrorMessage name="pricemultiplier" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isdefault 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isdefault"  onChange={formik.handleChange}  value={formik.values.isdefault}   label="Isdefault" type="text" placeholder="Enter Isdefault"        className={inputClassName(formik?.errors?.isdefault)} />
                                                <ErrorMessage name="isdefault" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="createdat"  onChange={formik.handleChange}  value={formik.values.createdat}   label="Createdat" type="text" placeholder="Enter Createdat"        className={inputClassName(formik?.errors?.createdat)} />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
ItemtypetreatmentsAddPage.defaultProps = {
	primaryKey: 'treatmentid',
	pageName: 'itemtypetreatments',
	apiPath: 'itemtypetreatments/add',
	routeName: 'itemtypetreatmentsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ItemtypetreatmentsAddPage;
